type ChangelogStatus = string | null | undefined

// Only a run that was in flight in this session gets announced, so reopening an
// entry that already failed stays quiet.
export function shouldAnnounceGenerationFailure(
	previous: ChangelogStatus,
	next: ChangelogStatus,
): boolean {
	if (next !== "FAILED") return false
	if (!previous || previous === "FAILED" || previous === "COMPLETED") {
		return false
	}
	return true
}

const FINISHED = new Set(["COMPLETED", "FAILED"])

// The job clears the status when nothing shipped since the last changelog.
export function shouldAnnounceNothingNew(
	previous: ChangelogStatus,
	next: ChangelogStatus,
): boolean {
	return next === null && !!previous && !FINISHED.has(previous)
}
